import React from 'react';
import { Link } from 'react-router-dom';

function Privacy() {
  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <Link to="/" className="back-link">⬅ Retour au jeu</Link>
        <h1>Politique de confidentialité</h1>
        
        <h2>Propriétaire de l'application</h2>
        <p>
          patrickm.consulting<br />
          31 avenue du clos-banderet<br />
          74200 Thonon-les-bains<br />
          France<br />
          E-mail de contact: contact@patrickm.consulting
        </p>

        <h2>Types de données collectées, buts de la collecte</h2>
        <p>Aucune donnée personnelle n'est collectée !</p>
        <p>
          Nous ne collectons uniquement des données de statistique comme la version de l'application, 
          la durée d'utilisation et la version du système d'exploitation, qui ne sont pas de nature personnelle 
          et qui ne sont donc pas concernés par le RGPD.
        </p>
      </div>
    </div>
  );
}

export default Privacy;
